import { styledPolymorphic } from '@qred/components-library';

export const Container = styledPolymorphic<
  'div',
  {
    $stickyFooter: boolean;
    $fullHeight: boolean;
    $footerHeight: number;
  }
>()(
  (styled) => styled`
  overflow-y: auto;
  width: 100%;

  ${(props) =>
    props.$fullHeight ?? true
      ? `
        height: 100%;
      `
      : `
        margin: auto;
  `}

    ${(props) =>
      (props.$stickyFooter ?? true) &&
      `
        display: flex;
        flex-direction: column;
    `}

     ${({ theme, $footerHeight }) =>
       `${theme.fn.smallerThan('tablet')} {
        padding-bottom: ${$footerHeight}px;
        display: flex;
        flex: 1;
        margin: unset;
      }
    `}
  `
);

export const StepFooterWrapper = styledPolymorphic<
  'div',
  { $fixedFooter?: boolean; $isInIframe?: boolean }
>()(
  (styled) => styled`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${({ $isInIframe }) => ($isInIframe ? '24px 32px' : '1em')};

  ${({ theme, $isInIframe }) =>
    !$isInIframe &&
    `${theme.fn.largerThan('tablet')} {
      padding: 1em 2em;
    }
  `}
  background-color: ${({ theme }) =>
    theme.fn.themeColor('Container/Option_2_(White)')};

  ${({ theme, $fixedFooter, $isInIframe }) =>
    ($fixedFooter ?? true) &&
    `
      background-color: ${
        $isInIframe
          ? theme.fn.themeColor('Container/Option_1_(Greige_I)')
          : theme.fn.themeColor('Main/Secondary/Greige/100')
      };
      border-top: 1px solid ${theme.fn.themeColor(
        'Main/Grey/Alpha/OnLight/10%'
      )};
      z-index: 1;
  `}

  ${({ theme }) =>
    `${theme.fn.smallerThan('tablet')} {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  `}
`
);

export const StepContent = styledPolymorphic<
  'div',
  {
    $lockStep?: boolean;
    $isInIframe?: boolean;
  }
>()(
  (styled) => styled`
    background-color: ${({ theme, $isInIframe }) =>
      $isInIframe
        ? 'transparent'
        : theme.fn.themeColor('Container/Option_2_(White)')};
    pointer-events: ${(props) => (props.$lockStep ? 'none' : 'initial')};
    padding: ${({ $isInIframe }) => ($isInIframe ? '24px 32px' : '32px')};
    gap: 24px;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex-grow: 1;
    ${({ theme, $isInIframe }) =>
      `${theme.fn.smallerThan('tablet')} {
          padding: ${$isInIframe ? `24px 32px` : `24px 16px`};
      }
    `}
  `
);
